import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  rightHalfLayout: {
    backgroundColor: theme.nonMuiTheme.colors.coolGray.cool150,
    paddingBottom: '30px',
    paddingTop: '30px',
  },
}))
